import React from 'react'
import { FormattedMessage } from 'react-intl'

/**
 *  Pop up showed when you have finished the game
 */
const EndSessionScreen = () => (
  <div className="popup--background popup--puzzle">
    <FormattedMessage id={'endTurn.loading'} />
  </div>
)

export default EndSessionScreen
